export interface PageData {
  path: string | string[];
  excludePaths?: string | string[];
  component: any;
  isMobileOnly?: boolean;
  isDesktopOnly?: boolean;
  isBottomNavigatorScreen?: boolean;
}

export enum AppScreen {
  DASHBOARD = "dashboard",
  TRADES = "trades",
  MARKETPLACE = "marketplace",
  ACCOUNTS = "accounts",
  ASSETS = "assets",
  POSITIONS = "positions",
  PORTFOLIO = "portfolio",
  GROUP_MANAGEMENT = "groupManagement",
  ADMIN_SIGNALS = "adminSignals",
  SIGNALS = "signals",
  USER_SIGNALS = "userSignals",
  ADMIN_TRADING_CONFIGURATION = "adminTradingConfiguration",
  AFFILIATION = "affiliation",
  BILLING = "billing",
  ONBOARDING = "onboarding",
  CANCEL_SUBSCRIPTION = "cancelSubscription",
  WATCHLIST = "watchlist",
  BOT_FORM = "botForm",
  PUBLIC_BOT_PREVIEW = "publicBotPreview",
  MY_GROUPS = "myGroups",
  TRADING_TERMINAL = "tradingTerminal",
  SIGNAL_TERMINAL = "signalTerminal",
  SETTINGS = "settings",
  BACKTESTING = "backtesting",
  PUBLIC_BOTS = "publicBots",
  MY_BOTS = "myBots",
  BOTS = "bots",
  NOTIFICATIONS_MANAGEMENT = "notificationsManagement",
  ACCOUNT_AND_SECURITY = "accountAndSecurity",
  TRADINGVIEW_TO_SIGNAL = "tradingviewToSignal",
  CONNECT_WHOP_CHANNEL = "connectWhopChannel",
  WHOP_CHANNEL_ERROR = "whopChannelError",
  INVOICES = "invoices",
  BUSINESS_PROFILE = "businessProfile",
  USERS_MANAGEMENT = "usersManagement",
  MCP = "mcp",
  FINANCE = "finance",
}
